const env = {
	SECRET_KEY: process.env.SECRET_KEY,
	BASE52: process.env.BASE52,
	JWT_SECRET: process.env.JWT_SECRET,
	BOT_API_URL: process.env.BOT_API_URL,
	BACK_API_URL: process.env.BACK_API_URL,
	BOT_TOKEN: process.env.BOT_TOKEN,
	SECRET: process.env.SECRET,

	PUBLIC_TG_BOT_USERNAME: process.env.NEXT_PUBLIC_TG_BOT_USERNAME,
	PUBLIC_TG_BOT_NAME: process.env.NEXT_PUBLIC_TG_BOT_NAME,
	PUBLIC_TG_BOT_URL: process.env.NEXT_PUBLIC_TG_BOT_URL,

	PUBLIC_TG_CHANEL_USERNAME: process.env.NEXT_PUBLIC_TG_CHANEL_USERNAME,
	PUBLIC_TG_CHANEL_NAME: process.env.NEXT_PUBLIC_TG_CHANEL_NAME,
	PUBLIC_TG_CHANEL_URL: process.env.NEXT_PUBLIC_TG_CHANEL_URL,

	PUBLIC_DOMAIN: process.env.NEXT_PUBLIC_DOMAIN,
	PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
	PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
};

export default env;
